<template>
  <div class="mt-1" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch()">
          <div class="filter">
            <div class="filter-item" data-type="registry-group">
              <div>
                <b-button-toolbar>
                  <b-button-group>
                    <base-input
                      :class="{
                        'filter-item-inner-wrapped': true,
                      }"
                      name="Anagrafica"
                      label="Anagrafica"
                      v-model="form.inpt_label_registry"
                      :readonly="true"
                    />
                    <b-button
                      class="btn-quick btn--light"
                      size="sm"
                      text="Button"
                      variant="lisaweb"
                      title="Cerca anagrafica"
                      @click="openQuickSearchRegistry"
                    >
                      <base-icon
                        name="search"
                        width="14"
                        height="14"
                      ></base-icon>
                    </b-button>
                    <b-button
                      v-if="form.inpt_label_registry"
                      class="btn--light btn--alert"
                      size="sm"
                      text="Button"
                      variant="lisaweb"
                      @click="resetRegistryId"
                      title="Elimina anagrafica"
                    >
                      <base-icon
                        name="trash"
                        width="22"
                        height="22"
                      ></base-icon>
                    </b-button>
                  </b-button-group>
                </b-button-toolbar>
              </div>
            </div>
            <quick-search-registry-modal
              ref="quickSearchRegistry"
              @input="handleRegistryModalInput"
            >
            </quick-search-registry-modal>
            <div class="filter-item" data-type="registry-group-info">
              <div class="details-card-wrapper" v-if="registry_data">
                <b-card>
                  <div
                    slot="header"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="mb-0 d-inline-block align-middle">
                      <strong>Informazioni anagrafica selezionata</strong>
                    </p>
                  </div>
                  <div
                    class="custom-grid-wrapper"
                    v-html="toInfoData(registry_data, 'registry')"
                  ></div>
                </b-card>
              </div>
            </div>
            <!-- una volta scelto il registry, di fianco deve comparire:
            - o una tendina con i gruppi, con preselezionato gruppo principale (dipende da parametro di agenzia)
            - o una tendina in multiselect con tutte le relazioni (di parentela) di quel registry -->
            <div class="filter-item" v-if="showGroups">
              <base-select
                name="groups-select"
                label="Gruppi"
                :options="opt_groups"
                v-model="filter.byRegistryGroup.id"
                @select="onSelectRegistryGroup"
              />
            </div>
            <div class="filter-item" v-if="showRelations">
              <base-select
                name="relations-multiselect"
                label="Relazioni"
                :options="opt_relations"
                :multiple="true"
                v-model="byRegistryRegistry.id"
                @select="onSelectRegistryRegistry"
              />
              <!-- il problema è che il v-model "filter.byRegistry.id" è lo stesso nei 2 casi in OR ESCLUSIVO -->
              <!-- in appoggio su "byRegistryRegistry", per poi convertirlo opportunamente nella sumbit -->
            </div>
            <div class="filter-item">
              <base-month-picker
                id="to"
                vid="periodo_a"
                name="periodo_a"
                label="Escludi Titoli Q con scadenza a partire dal"
                v-model="filter.byCalendar.to"
                :clearable="true"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              :disabled="!filter.byRegistry.id"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
    </div>
    <div class="mt-2">
      <div>
        <span class="ml-3"
          v-html="
            isLoading && items.length
              ? 'Elaborazione in corso, attendere...'
              : ''
          "
        ></span>
        <b-overlay center :show="isLoading" rounded="sm">
          <div v-if="!isLoading">
            <div class="mt-1">
              <b-button
                v-show="Object.keys(model).length"
                type="button"
                :pressed.sync="myToggle"
                variant="light"
                class="btn btn--x-smaller btn--transparent ml-3 mb-2"
                size="sm"
                @click="onToggleSelectAll"
                :disabled="isToggling"
              >
                <b-spinner small type="grow" v-show="isToggling"></b-spinner>
                {{ myToggle ? "Deseleziona" : "Seleziona" }} tutti
              </b-button>
            </div>
            <sesana
              :fields="fields"
              :items="items"
              :performedSearch="computePerformedSearch"
              :filterCount="countActiveFilters"
              @manualFetch="manualFetch"
              @open_note="openNoteModal"
              @check="onSelectRow"
              @submit="onSubmit"
              v-model="model"
              :semColor="toSemColor"
              :elaColor="toElaColor"
            >
            </sesana>
            <b-row class="table-extra-footer">
              <p class="title">Da Incassare:</p>
              <div class="sem-green"></div>
              <p class="label">Recuperabile Totalmente</p>
              <div class="sem-yellow"></div>
              <p class="label">Recuperabile Parzialmente</p>
              <div class="sem-red"></div>
              <p class="label">Non Recuperabile</p>
            </b-row>
            <b-row class="table-extra-footer">
              <p class="title">Selezione:</p>
              <div class="check-green"></div>
              <p class="label">Acconto</p>
              <div class="check-red"></div>
              <p class="label">Sospeso</p>
            </b-row>
            <div class="table-extra-footer">
              <b-button
                type="button"
                variant="lisaweb"
                class="mt-2"
                size="sm"
                @click="onSubmit()"
                >Compensa
              </b-button>
            </div>
            <note-detail-modal :items="notes"></note-detail-modal>
          </div>
          <template #overlay>
            <div class="text-center">
              <div class="custom-loader"></div>
              <p class="loading-text">Operazione in corso...</p>
            </div>
          </template>
        </b-overlay>
      </div>
    </div>
    <b-modal
      id="modal-recupero-sospesi"
      title="Conferma Compensazione Acconti/Sospesi"
      size="md"
      ok-title="Procedi"
      cancel-title="Annulla"
      header-bg-variant="lisaweb"
      header-text-variant="light"
      ok-variant="lisaweb"
      cancel-variant="-transparent"
      @ok="handleOk"
    >
      <template v-slot:modal-header-close>
        <base-icon name="close" width="14" height="14" />
      </template>
      <div class="p-3" style="height: 400px;">
        <base-datepicker
          label="Prima di procedere, selezionare la data di compensazione"
          v-model="dataSelezionata"
        />
      </div>
    </b-modal>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import QuickSearchRegistryModal from "@/components/modals/quickSearchRegistry";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseMonthPicker from "@/components/form/BaseMonthPicker";
import BaseDatepicker from "../../../form/BaseDatepicker.vue";
import NoteDetailModal from "@/components/modals/noteDetailModal";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { prepareFilterQueryString } from "@/utils/forms";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate, fromLastDayPreviousMonth } from "@/utils/dates";
import { toInfoData, toRelationString } from "@/utils/transforms";
import { mergeIndex } from "@/utils/advance-payments";
import common from "@/components/accounting/advance-payment/common";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";
import Sesana from "../table.vue";

export default {
  extends: common,
  name: "sesana-clienti",
  mixins: [SidebarFilterMixin],
  data() {
    return {
      tableIdentifier: "sesana-clienti",
      isLoading: false,
      notes: [],
      items: [],
      items1: [],
      items2: [],
      items3: [],
      items4: [],
      items5: [],
      items6: [],
      items7: [],
      dataSelezionata: null,
      selectedNegRows: [],
      selectedPosRows: [],
      negIds: [],
      posIds: [],
      sem: {}, // semaphores for deferreds
      ela: {}, // elaborated accounts
      filter: this.initFilter(),
      activeFilters: {},
      performedSearch: false,
      showGroups: false,
      showRelations: false,
      byRegistryRegistry: {
        id: null,
      },
      registry_data: null,
      registry_group_data: null,
      form: {
        input_label_registry_group: "",
        input_label_registry: "",
        quick_value: "",
      },
      table: {
        filterOn: {
          byRelations: [
            // "byBroker",
            "byRegistry",
            // "byInsurer",
            "byInsuranceAncillary",
            "byVariousAccounting",
            "byTask",
          ],
        },
      },
      resource: "book_entries",
      repository: "book_entry",
      opt_groups: [],
      opt_relations: [],
      fields: [
        {
          key: "type",
          label: "Tipo",
          thClass: "xxxsw",
        },
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          formatter: (value) => toLocaleDate(value),
          thClass: "sw",
        },
        {
          key: "insurance_policy_number",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
          thClass: "mw",
        },
        {
          key: "registry",
          label: this.getDictionary("registry", "book_entry"),
          thClass: "lw",
        },
        {
          key: "check1",
          type: "checkbox",
          label: this.getDictionary("Sel."),
          thClass: "check zi2",
          tdClass: "check",
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "book_entry"),
          formatter: (value) => toLocaleCurrency(value),
          thClass: "sw text-right",
          tdClass: "text-right",
        },
        {
          key: "money",
          label: this.getDictionary("Da Incassare"),
          formatter: (value) => toLocaleCurrency(value),
          thClass: "sw text-right",
          tdClass: "text-right",
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
          thClass: "xxxsw text-right",
          tdClass: "float-right",
        },
      ],
      model: {},
      myToggle: false, // #943: select/deselect all checkboxes by button
      isToggling: false,
    };
  },
  components: {
    Sesana,
    BaseIcon,
    BaseDatepicker,
    QuickSearchRegistryModal,
    BaseInput,
    BaseSelect,
    BaseMonthPicker,
    NoteDetailModal,
  },
  computed: {
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computeActiveFilters() {
      return this.retriveActiveFilters();
    },
  },
  methods: {
    toInfoData,
    initFilter() {
      let init = {
        byAttribute: {
          title: null,
        },
        byRegistry: {
          id: null,
        },
        byRegistryGroup: {
          id: null,
        },
        byCalendar: {
          from: null,
          to: null,
        },
      };
      return init;
    },
    openNoteModal(array) {
      this.notes = array;
      this.$bvModal.show("noteDetailModal");
    },
    onSelectRegistryGroup(selected) {
      // deseleziono l'altro
      if (selected) {
        this.$set(this.byRegistryRegistry, "id", null);
      }
    },
    onSelectRegistryRegistry(selected) {
      // deseleziono l'altro
      if (selected) {
        this.$set(this.filter.byRegistryGroup, "id", null);
      }
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      Object.keys(this.activeFilters).forEach((key) => {
        if (key !== "byCalendar.to._i" && key !== "byRegistry.id") {
          delete this.activeFilters[key];
        }
      });

      return this.activeFilters;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.items = [];
      this.items1 = [];
      this.items2 = [];
      this.items3 = [];
      this.items4 = [];
      this.items5 = [];
      this.items6 = [];
      this.items7 = [];
      this.selectedNegRows = [];
      this.selectedPosRows = [];
      this.negIds = [];
      this.posIds = [];
      this.model = {};
      this.sem = {};
      this.ela = {};
      this.open_filter = true;
    },
    handleOk(bvModalEvent) {
      if (!this.dataSelezionata) {
        bvModalEvent.preventDefault();
        this.$showSnackbar({ preset: "error", text: "Seleziona una data" });
        return;
      }
      this.submit();
    },
    onSearch() {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      this.items = [];
      this.isLoading = true;
      this.selectedNegRows = [];
      this.selectedPosRows = [];
      // prepare the month-picker dates
      // let s = fromFirstDay(this.filter.byCalendar.from);
      // let e = toLastDay(this.filter.byCalendar.to);

      let brId = this.filter.byRegistry.id;
      // se è selezionato il gruppo: lascio visibile il registry ma non invio filter.byRegistry.id
      if (this.filter.byRegistryGroup.id) {
        // this.resetRegistryId();
        this.filter.byRegistry.id = null;
      }
      // se ci sono le relazioni (byRegistryRegistry), metto gli id in byRegistry
      let brrId = this.byRegistryRegistry.id;
      if (brrId && brrId.length) {
        this.filter.byRegistry.id = [brId];
        for (let rId of this.byRegistryRegistry.id) {
          this.filter.byRegistry.id.push(rId);
        }
        // brrId = this.byRegistryRegistry.id;
        this.byRegistryRegistry.id = null;
      }
      // let criteria = Object.assign({}, this.filter);
      // escludo byCalendar perché lo usa solamente index3
      let { byCalendar, ...criteria } = this.filter;
      // let { ...criteria } = this.filter;
      // set the calculated form values
      // TODO: byCalendar solo per la index 3
      let calendar = fromLastDayPreviousMonth(byCalendar.to); //TODO aggiungere dal giorno precedente a firstDay

      // prepare the queryString
      let qs = {};
      // noPagination
      qs.pagination = "perPage=0";
      if (this.table.filterOn && Object.keys(this.table.filterOn).length) {
        let filterOn = prepareFilterQueryString(this.table.filterOn);
        if (filterOn) {
          qs.filterOn = filterOn;
        }
      }

      let criteria1 = { ...criteria };
      // criteria1.byView = "deferred";
      criteria1.byDeferred = "yes";
      // DEBUG
      // for (let i of [1, 2, 3, 4]) {
      //   console.debug(`criteria${i}: `, eval(`criteria${i}`));
      // }

      let criteria2 = { ...criteria };
      // DEBUG: replace with the correct filter by???
      criteria2.byDeposited = "yes";

      // let criteria3 = { ...criteria };
      // criteria3.byAttribute = {};
      // criteria3.byAttribute.payment_type = [1, 2];
      // criteria3.byCalendar = {};
      // criteria3.byCalendar.from = calendar;
      // criteria3.byCalendar.to = calendar;

      let criteria4 = { ...criteria };
      criteria4.byAttribute = {};
      criteria4.byAttribute.status_payment = 0;

      let criteria5 = { ...criteria };
      criteria5.byAttribute = {};
      criteria5.byAttribute.status_ancillary = 0;
      criteria5.byAttribute.code = "A";

      let criteria6 = { ...criteria };
      criteria6.byAttribute = {};
      criteria6.byAttribute.status_ancillary = 0;
      criteria6.byAttribute.code = "P";

      // let { byCalendar, ...criteria } = this.filter;
      let criteria7 = { byCalendar, ...criteria };
      criteria7.byAttribute = {};
      criteria7.byAttribute.status_ancillary = 0;
      criteria7.byAttribute.code = "Q";
      criteria7.byCalendar = {};
      criteria7.byCalendar.from = calendar ? "1900-01-01" : calendar;
      criteria7.byCalendar.to = calendar;

      // ripristino i magheggi fatti per le "sparizioni" di byRegistryRegistry...
      this.byRegistryRegistry.id = brrId;
      // this.filter.byRegistry.id = brId; // CHECK BOH!? perchè poi criteria1 non ha tutti i registry???

      let qs1 = { ...qs };
      let qs2 = { ...qs };
      // let qs3 = { ...qs };
      let qs4 = { ...qs };
      let qs5 = { ...qs };
      let qs6 = { ...qs };
      let qs7 = { ...qs };

      let filter1 = prepareFilterQueryString(criteria1);
      if (filter1) {
        qs1.filter = filter1;
      }
      let filter2 = prepareFilterQueryString(criteria2);
      if (filter2) {
        qs2.filter = filter2;
      }
      // let filter3 = prepareFilterQueryString(criteria3);
      // if (filter3) {
      //   qs3.filter = filter3;
      // }
      let filter4 = prepareFilterQueryString(criteria4);
      if (filter4) {
        qs4.filter = filter4;
      }
      let filter5 = prepareFilterQueryString(criteria5);
      if (filter5) {
        qs5.filter = filter5;
      }
      let filter6 = prepareFilterQueryString(criteria6);
      if (filter6) {
        qs6.filter = filter6;
      }

      let filter7 = prepareFilterQueryString(criteria7);
      if (filter7) {
        qs7.filter = filter7;
      }

      //   La index sarà il merge di 4 index:
      // - 1. book_entry con un filtro residuo sospeso > 0 (byDeferred)
      // - 2. book_entry con un filtro nuovo: acconto residuo > 0 (by???)
      // - 3. insurance_payment (quetanzamenti) di tipo 1 e 2 (byAttribute[payment_type]=1,2) + Fino A ByCalendar.to
      // => prendere insurance_ancillary
      // - 4. assegni postdatati (N/A) (tutti quelli non incassati)

      let queryString1 = Object.values(qs1).join("&");
      let queryString2 = Object.values(qs2).join("&");
      // let queryString3 = Object.values(qs3).join("&");
      let queryString4 = Object.values(qs4).join("&");
      let queryString5 = Object.values(qs5).join("&");
      let queryString6 = Object.values(qs6).join("&");
      let queryString7 = Object.values(qs7).join("&");

      let Repo1 = RepositoryFactory.get(this.repository);
      let Repo2 = RepositoryFactory.get(this.repository);
      // let Repo3 = RepositoryFactory.get("insurance_payment");
      let Repo4 = RepositoryFactory.get("unsolved_payment");
      let Repo5 = RepositoryFactory.get("insurance_ancillary");
      let Repo6 = RepositoryFactory.get("insurance_ancillary");
      let Repo7 = RepositoryFactory.get("insurance_ancillary");

      const i1 = Repo1.index(queryString1);
      const i2 = Repo2.index(queryString2);
      // const i3 = Repo3.index(queryString3);
      const i3 = null;
      const i4 = Repo4.index(queryString4);
      const i5 = Repo5.index(queryString5);
      const i6 = Repo6.index(queryString6);
      const i7 = Repo7.index(queryString7);

      Promise.all([i1, i2, i3, i4, i5, i6, i7])
        .then((values) => {
          // set the itemX variables
          for (const [index, value] of values.entries()) {
            this[`items${index + 1}`] = value ? value.data.data : [];
          }
          this.items = mergeIndex(
            this.items1,
            this.items2,
            // this.items3,
            this.items4,
            this.items5,
            this.items6,
            this.items7,
          );
          // add check prop to data
          this.items = this.items.map((obj) => ({ ...obj, check: true }));
          this.negIds = this.items
            .filter((e) => e.type === "S")
            .map((e) => e.id);
          this.posIds = this.items
            .filter((e) => e.type === "A")
            .map((e) => e.id);

          this.model = {};
          for (const item of this.items) {
            let {
              id,
              book_entry_id,
              money,
              type,
              enabled,
              check /*, ...rest*/,
            } = item;
            this.$set(this.model, id, {
              id,
              book_entry_id,
              check,
              type,
              money,
              enabled,
            });

            if (item.type === "S") {
              this.selectedNegRows = this.pushSortedIds(
                item.id,
                this.selectedNegRows,
                this.negIds,
              );
            }
            if (item.type === "A") {
              this.selectedPosRows = this.pushSortedIds(
                item.id,
                this.selectedPosRows,
                this.posIds,
              );
            }
          }
          let s = this.semaphore(
            this.selectedNegRows,
            this.selectedPosRows,
            this.model,
          );
          let e = this.elaborate(
            this.selectedNegRows,
            this.selectedPosRows,
            this.model,
          );
          this.$set(this, "sem", null);
          this.$set(this, "sem", s);
          this.$set(this, "ela", null);
          this.$set(this, "ela", e);
          this.myToggle = true;
          this.isLoading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
          this.isLoading = false;
        })
        .finally(() => {
          // this.isLoading = false;
          // ripristino
          this.filter.byRegistry.id = brId;
        });
    },
    onClearFilter() {
      this.resetRegistryId();
      this.resetFilter();
    },
    openQuickSearchRegistry() {
      this.filter.byRegistry.id = null;
      this.$bvModal.show("quickSearchRegistryModal");
    },
    handleRegistryModalInput(value) {
      this.filter.byRegistry.id = value.id;
      this.registry_data = value;
      this.form.input_label_registry = this.toInfoData(
        this.registry_data,
        "registryfullname",
      );
      this.$bvModal.hide("quickSearchRegistryModal");
      this.loadRegistryGroupsByRegistry(value.id);
      this.showGroups = true;
      this.showRelations = true;
    },
    resetRegistryId() {
      this.registry_data = null;
      this.form.input_label_registry = null;
      this.filter.byRegistry.id = null;
      this.filter.byRegistryGroup.id = null;
      this.byRegistryRegistry.id = null;
      this.opt_groups = null;
      this.opt_relations = null;
      this.showGroups = false;
      this.showRelations = false;
    },
    loadRegistryGroupsByRegistry(id = null) {
      if (!id) {
        id = this.filter.byRegistry.id;
      }
      let Repo = RepositoryFactory.get("registry");
      let relationString = "relations/byRegistry/byRegistryGroup";
      Repo.show(id, relationString)
        .then((response) => {
          // console.log(response.data.data);
          this.opt_groups = response.data.data.registry_groups.map((e) => ({
            value: e.id,
            text: e.code,
          }));
          // se il parametro di agenzia lo prevede, seleziono di fefault i gruppo principale
          // TODO get the parameter!!!
          let agency_parameter = false;
          if (agency_parameter && this.opt_groups.length) {
            let found = response.data.data.registry_groups.find(
              (e) => e.pivot.primary === "Y",
            );
            if (found) {
              this.filter.byRegistryGroup.id = found.pivot.registry_group_id;
            }
          }
          this.opt_relations = response.data.data.registries.map((e) => ({
            value: e.id,
            text: `${toRelationString("registries", e, [
              "VIRTUAL_FULLNAME",
            ])} - ${e.pivot.relative_type.formatted_title}`,
          }));
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.title {
  margin-left: 14px;
  margin-right: 5px;
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.label {
  margin-left: 5px;
  margin-right: 5px;
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.sem-green {
  width: 15px;
  height: 15px;
  background: rgba(0, 255, 0, 0.4);
  margin-left: 18px;
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.sem-yellow {
  width: 15px;
  height: 15px;
  background: rgba(251, 255, 0, 0.4);
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.sem-red {
  width: 15px;
  height: 15px;
  background: rgba(255, 0, 0, 0.4);
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.check-green {
  width: 15px;
  height: 15px;
  background: radial-gradient(#56c456, white);
  margin-left: 18px;
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.check-red {
  width: 15px;
  height: 15px;
  background: radial-gradient(#af545186, white);
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}
</style>
